import {
  createTableColumn,
  TableColumnSizingOptions,
} from "@fluentui/react-components";
import { ExpandedColumn } from "library/types/columns";
import { useTranslation } from "react-i18next";
import { useGetTaxonomies } from "state/queries/useGetTaxonomies";

export const useTransformColumnsSizing = (
  defaultCols: ExpandedColumn[]
): TableColumnSizingOptions => {
  return defaultCols.reduce((acc, col) => {
    acc[col.key] = {
      defaultWidth: col.width,
    };
    return acc;
  }, {} as TableColumnSizingOptions);
};
